"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _link = _interopRequireDefault(require("@clayui/link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "disabled", "displayType", "href", "tag", "truncate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayCardDescription = function ClayCardDescription(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      displayType = _ref.displayType,
      href = _ref.href,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'p' : _ref$tag,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? true : _ref$truncate,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var InnerTag = href && !disabled ? _link.default : 'span';
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: (0, _classnames.default)(className, "card-".concat(displayType)),
    title: children ? children.toString() : undefined
  }, otherProps), truncate ? /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate-inline"
  }, /*#__PURE__*/_react.default.createElement(InnerTag, {
    className: "text-truncate",
    href: disabled ? undefined : href
  }, children)) : children);
};

var _default = ClayCardDescription;
exports.default = _default;